// El estilo de los chips de categoría — UNA fuente para Crear (las plantillas debajo de la
// caja, `modes/redes/PlantillasDeRedes`) y Recrear (`InterfazV2Plantillas`,
// `PlantillasBelleza`), ADR-2026-10-05-recrear-con-los-chips-y-el-parallax-de-crear.
//
// Los colores del interruptor Imagen/Video de la caja de Crear: el apagado es el gris del
// riel con el texto apagado; el elegido, la pastilla blanca con sombra suave y el texto en
// tinta. Esquinas de 10 px, menos redondos que una píldora. Sin borde: el chip mide 37 px
// (texto de 14 px + `py-2`), que es el alto del esqueleto.

export const CHIP = 'shrink-0 px-4 py-2 rounded-[10px] text-[14px] font-medium transition-colors';
export const CHIP_ACTIVO = 'bg-white text-brand-black shadow-[0_2px_8px_rgb(var(--brand-black-rgb)_/_0.08)] ring-1 ring-black/[0.04]';
export const CHIP_QUIETO = 'bg-[#E9EBF1] text-[rgb(var(--brand-black-rgb)_/_0.5)] hover:text-brand-black';

/** Las clases de un chip según esté elegido o no. */
export const claseDeChip = (activo: boolean): string => `${CHIP} ${activo ? CHIP_ACTIVO : CHIP_QUIETO}`;

/** El chip del esqueleto: mismo alto y mismas esquinas que el real. */
export const CHIP_ESQUELETO = 'h-[37px] shrink-0 rounded-[10px] bg-black/[0.06] animate-pulse';
